'use client';
import { useState } from 'react';

export default function CalculatorInvestment() {
  const [initialInvestment, setInitialInvestment] = useState(10000);
  const [monthlyContribution, setMonthlyContribution] = useState(500);
  const [annualReturn, setAnnualReturn] = useState(8);
  const [years, setYears] = useState(20);

  const monthlyRate = annualReturn / 100 / 12;
  const months = years * 12;
  const futureValue = initialInvestment * Math.pow(1 + monthlyRate, months) + monthlyContribution * ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate);
  const totalContributions = initialInvestment + (monthlyContribution * months);
  const totalEarnings = futureValue - totalContributions;

  return (
    <div className="bg-white rounded-3xl p-8 shadow-modern-xl">
      <h2 className="text-2xl font-bold mb-6">Investment Details</h2>
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-semibold mb-2">Initial Investment</label>
          <input type="number" value={initialInvestment} onChange={(e) => setInitialInvestment(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Monthly Contribution</label>
          <input type="number" value={monthlyContribution} onChange={(e) => setMonthlyContribution(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Annual Return (%)</label>
          <input type="number" step="0.1" value={annualReturn} onChange={(e) => setAnnualReturn(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
        <div>
          <label className="block text-sm font-semibold mb-2">Investment Period (years)</label>
          <input type="number" value={years} onChange={(e) => setYears(Number(e?.target?.value))} className="w-full px-4 py-3 border rounded-lg" />
        </div>
      </div>
      <div className="mt-8 space-y-4">
        <div className="p-6 bg-purple-50 rounded-xl">
          <h3 className="text-lg font-bold mb-2">Future Value</h3>
          <p className="text-3xl font-bold text-purple-600">${futureValue?.toFixed(2)}</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Total Contributions</p>
            <p className="text-xl font-bold text-slate-900">${totalContributions?.toFixed(2)}</p>
          </div>
          <div className="p-4 bg-slate-50 rounded-lg">
            <p className="text-sm text-slate-600">Total Earnings</p>
            <p className="text-xl font-bold text-slate-900">${totalEarnings?.toFixed(2)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
